import { useState } from 'react';
import axios from 'axios';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

import styles from './NewEvent.module.css';

import InputForm from '../../components/InputForm';
import Title from '../../components/Title';
import Button from '../../components/Button';

export default function NewEvent() {
  const navigate = useNavigate();
  const token = localStorage.getItem('accessToken');
  const [createEvent, setCreateEvent] = useState({
    nome: '',
    descricao: '',
    local: '',
    endereco: '',
    data: '',
    imagem: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCreateEvent({
      ...createEvent,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setCreateEvent({
      ...createEvent,
      imagem: file,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!createEvent.imagem) {
      alert('Por favor, selecione uma imagem para o evento');
      return;
    }
    
    const formData = new FormData();
    formData.append('nome', createEvent.nome);
    formData.append('descricao', createEvent.descricao);
    formData.append('local', createEvent.local);
    formData.append('endereco', createEvent.endereco);
    formData.append('data', `${createEvent.data}:00`);
    formData.append('imagem', createEvent.imagem);

    axios.post('https://back-cultura-sje-production.up.railway.app/eventos', formData, {
      headers: { 
        Authorization: `Bearer ${ token }`,
        'Content-Type': 'multipart/form-data' 
      }
    })
      .then(() => {
        setCreateEvent({
          nome: '',
          descricao: '',
          local: '',
          endereco: '',
          data: '',
          imagem: null
        });

        alert('Evento criado com sucesso.')
      })
      .catch((error) => {
        console.error('Erro no envio do formulario',  JSON.stringify(error, null, 2));
      }) 
    }

  return (
    <main className={styles.page}>
      
      <div className={styles.container}>
        <button onClick={() => navigate('/painel-administrativo')} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BiArrowBack size={24} />
          Voltar
        </button>
        <Title color='var(--brown-300)'>Criar evento</Title>

        <div className={styles.formContainer}>
          <form onSubmit={handleSubmit}>
            <InputForm 
              mode='input'
              type='text'
              title='Nome do evento'
              name='nome'
              placeholder='Digite o nome do evento'
              value={createEvent.nome}
              onChange={handleChange}
            />
            <InputForm
              mode='textarea'
              title='Descrição'
              name='descricao'
              placeholder='Descreva o evento'
              value={createEvent.descricao}
              onChange={handleChange}
            />
            <InputForm
              mode='input'
              type='text'
              title='Local do evento'
              name='local'
              placeholder='Digite o local do evento'
              value={createEvent.local}
              onChange={handleChange}
            />
            <InputForm
              mode='input'
              type='text'
              title='Endereço'
              name='endereco'
              placeholder='Digite o endereço do evento'
              value={createEvent.endereco}
              onChange={handleChange}
            />
            <InputForm
              mode='input'
              type='datetime-local'
              title='Data e Hora'
              name='data'
              value={createEvent.data}
              onChange={handleChange}
            />
            <InputForm
              mode='input'
              type='file'
              title='Capa'
              name='imagem'
              onChange={handleFileChange}
              accept='image/*'
            />
            <div className={styles.formButton}>
              <Button>Enviar</Button>
            </div>
          </form>
        </div>
      </div>
    </main>
  )
}
